import { get } from 'lodash-es';
import { useMediaQuery } from 'react-responsive';

import { MediaStepEnum } from '@enum/style/media-step.enum';

export const useMediaStep = <T = number>(...values: T[]) => {
  const isDesktop = useMediaQuery({ minWidth: 1440 });
  const isNotepad = useMediaQuery({ minWidth: 1280 });
  const isTablet = useMediaQuery({ minWidth: 768 });

  const value = isDesktop
    ? MediaStepEnum.Desktop
    : isNotepad
      ? MediaStepEnum.Notepad
      : isTablet
        ? MediaStepEnum.Tablet
        : MediaStepEnum.Mobile;

  return get(values, value, MediaStepEnum.Desktop);
};
